
import {Component, Vue} from "vue-property-decorator";
import UserCreateDialog from "./UserCreateDialog.vue";
import UserEditDialog from "./UserEditDialog.vue"
import ConfirmDialog from "../ConfirmDialog.vue";
import {MdbsCore} from "@/api/tsclient";
import {currentUserModule, rolesModule, usersModule} from "@/store";
import IUserUpdateDto = MdbsCore.IUserUpdateDto;
import IUserCreateDto = MdbsCore.IUserCreateDto;
import UserCreateDto = MdbsCore.UserCreateDto;
import IUserDto = MdbsCore.IUserDto;
import PersonDataDto = MdbsCore.PersonDataDto;
import UserUpdateDto = MdbsCore.UserUpdateDto;
import Rights = MdbsCore.Rights;
import IShortUserDto = MdbsCore.IShortUserDto;
import UserDto = MdbsCore.UserDto;
import {canSeeUserAuditTrail} from "@/auxillary/audittrail.permissions";

@Component({
  methods: {canSeeUserAuditTrail},
  components: {
    UserEditDialog,
    UserCreateDialog,
    ConfirmDialog
  },
})
export default class UserTable extends Vue {
  search: string = "";

  toBeCreatedItem: IUserCreateDto | null = null;
  showCreateDialog = false;
  toBeUpdatedItem: IUserUpdateDto | null = null;
  toBeUpdatedItemIsDeactivated = false;
  showUpdateDialog = false;
  toBeDeletedItem: IShortUserDto | null = new UserDto();
  showDeleteDialog = false;

  headers: any = [
    {text: 'Anzeigename', value: 'displayName'},
    {text: 'Benutzername', value: 'userName'},
    {text: 'Rolle', value: 'role.displayName'},
    {text: 'Email', value: 'email'},
    {text: 'Aktionen', value: 'actions', sortable: false, width: "155px", align: "center"}
  ];
  options: any = {
    sortBy: ['displayName'],
    sortDesc: [false]
  };

  get users() {
    return usersModule.users;
  }

  get loading() {
    return usersModule.isLoading || rolesModule.isLoading;
  }

  get canCreateUser() {
    return currentUserModule.hasRight(Rights.UserCreateCmd);
  }

  get canEditUser() {
    return currentUserModule.hasRight(Rights.UserUpdateCmd);
  }

  get canDeleteUser() {
    return currentUserModule.hasRight(Rights.UserDeactivateCmd);
  }

  async mounted() {
    await usersModule.loadAll();
  }

  createUser() {
    this.toBeCreatedItem = new UserCreateDto({
      userName: "",
      displayName: "",
      email: "",
      roleId: "",
      passwordString: "",
      noLogin: false,
      personData: new PersonDataDto()
    });

    this.showCreateDialog = true;
  }

  async updateUser(user: IUserDto) {
    await usersModule.getCompleteUserById(user.id);
    const completeUserById = usersModule.currentCompleteUser;

    this.toBeUpdatedItem = new UserUpdateDto({
      id: completeUserById.id,
      userName: completeUserById.userName ?? "",
      displayName: completeUserById.displayName ?? "",
      email: completeUserById.email ?? "",
      roleId: completeUserById.role?.id ?? "",
      personData: new PersonDataDto(completeUserById.personData),
    });
    this.toBeUpdatedItemIsDeactivated = completeUserById.isDeactivated ?? false;

    this.showUpdateDialog = true;
  }

  async deleteUser(user: IUserDto) {
    this.toBeDeletedItem = user;
    this.showDeleteDialog = true;
  }

  async handleDeleteUser() {
    if (this.toBeDeletedItem) {
      await usersModule.deleteUser(this.toBeDeletedItem.id);
    }

    this.showDeleteDialog = false;
  }

  async openAuditTrail(userId: string) {

    await this.navigate("useraudittrail", {
      userId: userId
    });
  }

  async navigate(name: string, params: any) {
    try {
      return await this.$router.push({name, params});
    } catch (error) {
      if (error.name !== 'NavigationDuplicated')
        throw error;
    }
  }
}
